// Load our styles
import '../css/fonts/MyFontsWebfontsKit.css'
import '../css/index.scss'
import '../js/plugin/location.js'

